import React, { useState, useEffect } from 'react';
import { LuPlayCircle } from "react-icons/lu";
import { learnerCourseListRes, learnerCourseListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearnerCourseList';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaFacebookMessenger, FaCirclePlus, FaRegBookmark, FaBookmark } from 'react-icons/fa6';
import AddFeedback from '../LMS_FEEDBACK/AddFeedback';
import { toast, ToastContainer } from 'react-toastify';
import { Accordion, Tab, Table, Tabs } from 'react-bootstrap';
import { learnerEnrollRes, learnerEnrollTodo } from '../../LMS_Redux/LMS_Slices/Course/LearnerEnroll';
import Swal from 'sweetalert2';
import { addBookmarkRes, addBookmarkTodo } from '../../LMS_Redux/LMS_Slices/Course/AddBookmark';
import { removeBookmarkRes, removeBookmarkTodo } from '../../LMS_Redux/LMS_Slices/Course/RemoveBookmark';

export default function LearnerCourseList() {

    const state = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.learnerCourseList && state.learnerCourseList.data && state.learnerCourseList.data.data)
    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [feedbackModalData, setFeedbackModalData] = useState()
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const courseData = [
        {
            headerName: 'IMAGE',
            field: 'lms_master_course.thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'lms_master_course.course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'lms_master_course.course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REVISION',
            field: 'lms_master_course.revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EXPIRES ON',
            field: 'course_exp_date',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
            minWidth: 160,
        },
        // {
        //     headerName: 'STATUS',
        //     field: 'status',
        //     cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true
        // },
        {
            headerName: 'STATUS',
            field: 'learner_course_status',
            cellRenderer: params =>
                params.value == 'pass' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> :
                    params.value == 'failed' || params.value == 'expired' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> :
                        params.value == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{params.value}</span> :
                            params.value == 'started' ? <span className='badge text-bg-info text-capitalize'>{params.value}</span>
                                : '',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'PROGRESS',
            field: 'progress_bar',
            cellRenderer: (params) =>
                <div className="progress" role="progressbar" aria-label="Success example" aria-valuenow={params.value} aria-valuemin="0" aria-valuemax="100" style={{ marginTop: '13px' }}>
                    <div className="progress-bar bg-success" style={{ "width": params.value + '%' }}>{params.value + '%'}</div>
                </div>
            ,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <LuPlayCircle size={20} className='eye'
                        onClick={() => course_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Details!"
                        data-tooltip-place="bottom"
                    />

                    {params.data.learner_course_status == 'pass' && params.data.feedback_status == 'pending' ?
                        <FaFacebookMessenger size={20} className='archive ms-3'
                            onClick={() => add_feedback(params)}
                            data-tooltip-id='feedback'
                            data-tooltip-content="Feedback!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    {params?.data?.lms_master_course?.lms_bookmark ?
                        <FaBookmark size={20} className='bookmark ms-3'
                            onClick={() => remove_bookmark(params)}
                            data-tooltip-id='remove-bookmark'
                            data-tooltip-content="Remove Bookmark!"
                            data-tooltip-place="bottom"
                        />
                        :
                        <FaRegBookmark size={20} className='bookmark ms-3'
                            onClick={() => add_bookmark(params)}
                            data-tooltip-id='bookmark'
                            data-tooltip-content="Bookmark!"
                            data-tooltip-place="bottom"
                        />
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='feedback' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='bookmark' style={{ backgroundColor: "rgb(3, 44, 66)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='remove-bookmark' style={{ backgroundColor: "rgb(3, 44, 66)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ]

    const myCourseData = [
        {
            headerName: 'IMAGE',
            field: 'thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REVISION',
            field: 'revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'lms_course_approvals',
            valueFormatter: function (params) {
                // Custom formatting logic here
                return params && params.value && params.value[0] && params.value[0].approval_status
            },
            cellRenderer: (params) =>
                params.valueFormatted == 'approved' ? <span className='badge text-bg-success text-capitalize'>{params.valueFormatted}</span> :
                    params.valueFormatted == 'rejected' ? <span className='badge text-bg-danger text-capitalize'>{params.valueFormatted}</span> :
                        params.valueFormatted == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{params.valueFormatted}</span> :
                            '-',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    {params.data.lms_course_approvals && params.data.lms_course_approvals.length == 0 || params.data.lms_course_approvals && params.data.lms_course_approvals.length && params.data.lms_course_approvals[0] && params.data.lms_course_approvals[0].approval_status == 'rejected' ?
                        <FaCirclePlus size={20} className='eye'
                            onClick={() => course_enroll(params)}
                            data-tooltip-id='enroll'
                            data-tooltip-content="Enroll!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    <Tooltip id='enroll' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ]

    const course_details = (params) => {
        navigate('/learner_course_details', { state: params.data })
    }

    const track_course_details = (params) => {
        navigate('/learner_course_details', { state: params })
    }

    const add_feedback = (params) => {
        setModalLoading(true)
        setFeedbackModalData({ "course_id": params.data.course_id, "training_id": params.data.fk_training_id })
        setFeedbackModal(true)
    }

    const track_add_feedback = (params) => {
        setModalLoading(true)
        setFeedbackModalData({ "course_id": params.course_id, "training_id": params.fk_training_id })
        setFeedbackModal(true)
    }

    const add_bookmark = (params) => {
        dispatch(addBookmarkTodo({ "course_id": params.data.course_id })).then(() => bookmark_res())
    }

    const bookmark_res = () => {
        if (addBookmarkRes?.success) {
            toast.success(addBookmarkRes?.message, { position: "bottom-right" })
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": key == 'course' ? 'Course Wise' : key == 'training' ? 'Learning Track' : 'My Courses' })).then(() => course_res())
        }
    }

    const remove_bookmark = (params) => {
        dispatch(removeBookmarkTodo({ "bookmark_id": params.data.lms_master_course.lms_bookmark?.id })).then(() => remove_bookmark_res())
    }

    const remove_bookmark_res = () => {
        if (removeBookmarkRes?.success) {
            toast.success(removeBookmarkRes?.message, { position: "bottom-right" })
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": key == 'course' ? 'Course Wise' : key == 'training' ? 'Learning Track' : key == 'bookmark' ? 'Bookmark' : 'My Courses' })).then(() => course_res())
        }
    }

    const course_enroll = (params) => {
        // console.log(params.data)
        Swal.fire({
            title: 'Learning Module Enroll',
            text: `Are you sure want to enroll for this Learning Module?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data)
                // setLoading(true)
                dispatch(learnerEnrollTodo(params.data)).then(() => enroll_res())
            }
        })
    }

    const enroll_res = () => {
        if (learnerEnrollRes && learnerEnrollRes.success) {
            Swal.fire(
                'Enroll Status',
                learnerEnrollRes.message,
                'success'
            )
            setBool(!bool)
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: learnerEnrollRes.message,
            })
        }
    }

    const course_res = () => {
        if (learnerCourseListRes && learnerCourseListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": state?.state == "bookmark" ? 'Bookmark' : key == 'course' ? 'Course Wise' : key == 'training' ? 'Learning Track' : 'My Courses' })).then(() => course_res())
    }, [bool])

    const [key, setKey] = useState(state?.state == "bookmark" ? 'bookmark' : 'course')

    const tab_change = (key) => {
        if (key == 'course') {
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": 'Course Wise' })).then(() => course_res())
        } else if (key == 'training') {
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": 'Learning Track' })).then(() => course_res())
        } else if (key == 'my_course') {
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": 'My Courses' })).then(() => course_res())
        } else if (key == 'bookmark') {
            setLoading(true)
            dispatch(learnerCourseListTodo({ "user_id": userRole.vemp_code, "training_type": 'Bookmark' })).then(() => course_res())
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Learning Module List</span>
                </div>

                <Tabs
                    // defaultActiveKey="course"
                    activeKey={key}
                    onSelect={(k) => { setKey(k); tab_change(k) }}
                    id="justify-tab-example"
                    className="piils_btn mb-3"
                    justify
                >
                    <Tab eventKey="course" title="Course List" disabled={loading}>
                        {key == 'course' &&
                            loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={courseData}
                                        height='60vh'
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>
                    <Tab eventKey="training" title="Learning Track" disabled={loading}>
                        {key == 'training' &&
                            loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <div className='wrapper-admin'>

                                        <Accordion defaultActiveKey={0}>
                                            {data && data.map((value, index) =>

                                                <Accordion.Item eventKey={index} key={index}>
                                                    <Accordion.Header>{value && value.lms_learning_track && value.lms_learning_track.learning_title}</Accordion.Header>
                                                    <Accordion.Body>
                                                        <Table bordered hover>
                                                            <thead>
                                                                <tr>
                                                                    <th>IMAGE</th>
                                                                    <th>TITLE</th>
                                                                    <th>ID</th>
                                                                    <th>REVISION</th>
                                                                    <th>EXPIRES ON</th>
                                                                    <th>STATUS</th>
                                                                    <th>PROGRESS</th>
                                                                    <th>ACTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {value && value.lms_training_users && value.lms_training_users.map((val, index1) =>
                                                                    <tr key={index1}>
                                                                        <td>
                                                                            {val && val.lms_master_course &&
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + `${val.lms_master_course.cover_image}`} alt="img" className='img-fluid' width="50" height="50" />
                                                                            }
                                                                        </td>
                                                                        <td>{val && val.lms_master_course && val.lms_master_course.course_title}</td>
                                                                        <td>{val && val.lms_master_course && val.lms_master_course.course_code}</td>
                                                                        <td>{val && val.lms_master_course && val.lms_master_course.revise}</td>
                                                                        <td>{val && val.course_exp_date}</td>
                                                                        <td>{
                                                                            val && val.learner_course_status == 'pass' ? <span className='badge text-bg-success text-capitalize'>{val && val.learner_course_status}</span> :
                                                                                val && val.learner_course_status == 'failed' || val && val.learner_course_status == 'expired' ? <span className='badge text-bg-danger text-capitalize'>{val && val.learner_course_status}</span> :
                                                                                    val && val.learner_course_status == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{val && val.learner_course_status}</span> :
                                                                                        val && val.learner_course_status == 'started' ? <span className='badge text-bg-info text-capitalize'>{val && val.learner_course_status}</span>
                                                                                            :
                                                                                            ''
                                                                        }
                                                                        </td>
                                                                        <td>
                                                                            <div className="progress" role="progressbar" aria-label="Success example" aria-valuenow={val && val.progress_bar} aria-valuemin="0" aria-valuemax="100" >
                                                                                <div className="progress-bar bg-success" style={{ "width": val && val.progress_bar + '%' }}>{val && val.progress_bar + '%'}</div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {val && val.course_start_status == 'start' || val && val.course_start_status == 'completed' ?
                                                                                <LuPlayCircle size={20} className='eye ms-1'
                                                                                    onClick={() => track_course_details(val)}
                                                                                    data-tooltip-id='details'
                                                                                    data-tooltip-content="Learning Module Details!"
                                                                                    data-tooltip-place="bottom"
                                                                                />
                                                                                : ''
                                                                            }

                                                                            {val && val.learner_course_status == 'pass' && val && val.feedback_status == 'pending' ?
                                                                                <FaFacebookMessenger size={20} className='archive ms-3'
                                                                                    onClick={() => track_add_feedback(val)}
                                                                                    data-tooltip-id='feedback'
                                                                                    data-tooltip-content="Feedback!"
                                                                                    data-tooltip-place="bottom"
                                                                                />
                                                                                : ''
                                                                            }

                                                                            <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                                                                            <Tooltip id='feedback' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            )}
                                        </Accordion>

                                    </div>
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>
                    <Tab eventKey="my_course" title="My Courses" disabled={loading}>
                        {key == 'my_course' &&
                            loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={myCourseData}
                                        height='60vh'
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>
                    <Tab eventKey="bookmark" title="Bookmark" disabled={loading}>
                        {key == 'bookmark' &&
                            loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={courseData}
                                        height='60vh'
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Bookmark List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>
                </Tabs>

            </div>
            <ToastContainer />
            <AddFeedback feedbackModal={feedbackModal} setFeedbackModal={setFeedbackModal} modalLoading={modalLoading} setModalLoading={setModalLoading} feedbackModalData={feedbackModalData} setFeedbackModalData={setFeedbackModalData} bool={bool} setBool={setBool} />
        </>
    );
}